import { getDomainData } from '../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../library/Service/axiosClient';

const BASE = () => `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/company`;

export interface CountryOption { code: string; label: string; }

let _countryCache: CountryOption[] | null = null;

class CompanyService {
    static pageLoader(params: any): Promise<any> {
        const id = params.id ?? 'new';
        if (id === 'new') {
            return Promise.resolve({ company: null, routeInfo: { ...params, id: 'new' } });
        }
        return axiosClient()
            .get(`${BASE()}/${id}`)
            .then((res: any) => ({ company: res.data?.data ?? null, routeInfo: params }))
            .catch(() => ({ company: null, routeInfo: params }));
    }

    static async getCountries(): Promise<CountryOption[]> {
        if (_countryCache) return _countryCache;
        try {
            const data = await getDomainData();
            if (!data) return [];
            const raw: any[] = Array.isArray(data) ? data : Object.values(data).flat();
            _countryCache = raw
                .filter((d: any) => d.categoryCode === 'COUNTRY_CODE')
                .sort((a: any, b: any) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
                .map((d: any) => ({ code: d.code, label: d.value }));
            return _countryCache;
        } catch {
            return [];
        }
    }

    static create(data: any): Promise<any> {
        return axiosClient().post(`${BASE()}/`, data);
    }

    static update(id: number, data: any): Promise<any> {
        return axiosClient().put(`${BASE()}/${id}`, data);
    }

    static async uploadFile(file: File): Promise<string | null> {
        const formData = new FormData();
        formData.append('pdf_doc', file);
        try {
            const response = await axiosClient().post(
                `${process.env.REACT_APP_COMMON_API}/upload/get-attached`,
                formData
            );
            return response.data?.link ?? null;
        } catch {
            return null;
        }
    }
}

export default CompanyService;
